import {MapPin, Mail, ArrowUp} from 'lucide-react'

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  return (
    <footer className="bg-emerald-950 text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <MapPin className="w-6 h-6 text-amber-400" />
              <span
                className="text-xl font-bold"
                style={{ fontFamily: "'DM Serif Display', serif" }}
              >
                LandMortgageCalculator
              </span>
            </div>
            <p className="text-emerald-300 text-sm leading-relaxed">
              The most comprehensive free land financing calculator and land contract payment tool. 
              Built for buyers, sellers, and real estate professionals working with land transactions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider mb-4 text-emerald-300">
              Calculator Tools
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#calculator" className="text-emerald-200 hover:text-white transition-colors">
                  Land Mortgage Calculator
                </a>
              </li>
              <li>
                <a href="#features" className="text-emerald-200 hover:text-white transition-colors">
                  Balloon Payment Calculator
                </a>
              </li>
              <li>
                <a href="#features" className="text-emerald-200 hover:text-white transition-colors">
                  Amortization Schedule Generator
                </a>
              </li>
              <li>
                <a href="#faq" className="text-emerald-200 hover:text-white transition-colors">
                  Land Financing FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Keywords / Resources */}
          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider mb-4 text-emerald-300">
              Resources
            </h4>
            <ul className="space-y-2 text-sm">
              <li className="text-emerald-200">Raw Land Mortgage Calculator</li>
              <li className="text-emerald-200">Hunting Land Mortgage Calculator</li>
              <li className="text-emerald-200">Land Equity Calculator</li>
              <li className="text-emerald-200">Land Note Calculator</li>
            </ul>
            <div className="mt-4 flex items-center gap-2 text-emerald-300 text-sm">
              <Mail className="w-4 h-4" />
              <span>support@landmortgagecalculator.com</span>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-emerald-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-emerald-400 text-xs">
            &copy; {new Date().getFullYear()} LandMortgageCalculator.com. All rights reserved. 
            This calculator provides estimates only and should not be considered financial advice.
          </p>
          <button
            onClick={scrollToTop}
            className="flex items-center gap-1.5 px-4 py-2 bg-emerald-800 rounded-lg text-emerald-200 text-sm font-medium hover:bg-emerald-700 transition-colors"
            aria-label="Back to top"
          >
            <ArrowUp className="w-4 h-4" />
            Back to Top
          </button>
        </div>
      </div>
    </footer>
  )
}
